module.exports = {};



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_iterators.js
 ** module id = 245
 ** module chunks = 1
 **/